<template>
  <div class="operate">
    <div class="search">
      <div class="statistics">
        <div>
          <span>总收入：</span>
          <span class="black-grey">{{ totalRevenue }}</span>
        </div>
        <div>
          <span>总成本：</span>
          <span class="black-grey">{{ totalCost }}</span>
        </div>
        <div>
          <span>总毛利：</span>
          <span class="gross-profit">{{ grossProfi }}</span>
        </div>
        <div>
          <span>每单毛利：</span>
          <span class="gross-profit">{{ itemOrderGrossProfi }}</span>
        </div>
      </div>
      <div class="search-left">
        <div class="search-left-content">
          <el-select
            v-model="warehouseId"
            clearable
            class="gray"
            placeholder="请选择仓库"
            @change="changeCostAllocationRules"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            class="gray paddingRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button class="btn-white paddingRight" @click="clearData">重置</el-button>
          <el-button class="btn-blue" @click="searchData">搜索</el-button>
        </div>
        <div class="search-right-content">
          <el-button class="btn-white paddingRight" @click="exportExit">导出</el-button>
          <el-button v-if="isShowArtificialSet" class="btn-white" @click="laborCostSet">人工成本设置</el-button>
        </div>
      </div>
    </div>
    <div class="table daily-details" v-if="isShowArtificialSet">
      <div class="daily-container">
        <div class="daily-title">物流费用</div>
        <el-table :data="expressFeeList" style="width: 100%">
          <el-table-column
          v-for="(item, index) in expressFeeTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
          </el-table-column>
        </el-table>
      </div>
      <div class="daily-container">
        <div class="daily-title">仓储费用</div>
        <el-table :data="warehouseAreaFeeList" style="width: 100%">
          <el-table-column
          v-for="(item, index) in warehouseAreaFeeListTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
          </el-table-column>
        </el-table>
      </div>
      <div class="daily-container">
        <div class="daily-title">操作费用</div>
        <el-table :data="operateFeeList" style="width: 100%">
          <el-table-column
          v-for="(item, index) in operateFeeListTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
          </el-table-column>
          <el-table-column prop="tempCost" :label="costAllocationRules == 1? '临时工成本':'toB成本'"></el-table-column>
          <el-table-column prop="regularCost" :label="costAllocationRules == 1? '正式工成本':'toC成本'"></el-table-column>
          <el-table-column prop="grossProfit" label="操作毛利"></el-table-column>
          <el-table-column prop="unitGrossProfit" label="每单毛利"></el-table-column>
        </el-table>
      </div>
      <div class="half-daily">
        <div class="daily-container">
          <div class="daily-title">索赔费用</div>
          <el-table :data="claimFeeList" style="width: 100%">
            <el-table-column
            v-for="(item, index) in claimFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width">
            </el-table-column>
          </el-table>
        </div>
        <div class="daily-container">
          <div class="daily-title">其他费用</div>
          <el-table :data="otherFeeList" style="width: 100%">
            <el-table-column
            v-for="(item, index) in otherFeeListTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width">
            </el-table-column>
          </el-table>
        </div>
      </div>
      
      <div class="daily-container">
        <div class="daily-title">其他成本</div>
        <el-table :data="otherCostList" style="width: 100%">
          <el-table-column
          v-for="(item, index) in otherCostListTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="table" v-if="isShowArtificialSet">
      <div class="table-container">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width">
            <template slot-scope="scope">
              <p :class="scope.row[item.prop] < 0 ? 'hign-red':''">{{scope.row[item.prop]}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.id"
                class="btn-text"
                @click="lookCustomerOrderNums(scope.row)"
                type="text"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 人工成本设置 -->
    <el-dialog title="人工成本设置" top="15vh" :visible.sync="laborCostSetDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="laborCostSetForm"
        :model="laborCostSetForm"
        label-width="100px"
      >
        <el-form-item :label="costAllocationRules == 1? '临时工成本：':'toB成本：'" prop="tempCost">
          <el-input
            v-model="laborCostSetForm.tempCost"
            class="white cost"
            @input="tempCostInput(laborCostSetForm.tempCost)"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item :label="costAllocationRules == 1? '正式工成本：':'toC成本：'" prop="regularCost">
          <el-input
            v-model="laborCostSetForm.regularCost"
            class="white cost"
            @input="regularCostInput(laborCostSetForm.regularCost)"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDecimal, formatTimeToDate, modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import Operate from "models/operate.js";
import Expenses from "models/expenses";
const expenses = new Expenses();
export default {
  data() {
    return {
      totalRevenue: '',
      totalCost: '',
      grossProfi: '',
      itemOrderGrossProfi: '',
      warehouseId: "",
      date: this.timeDefault(),
      warehouseList: [],
      tableData: [],
      tableTitleList: [
        {prop: 'customerName', label: '客户名称', width: ''},
        {prop: 'orderNum', label: '单量', width: ''},
        {prop: 'warehouseGrossProfit', label: '仓储毛利', width: ''},
        {prop: 'operateGrossProfit', label: '操作毛利', width: ''},
        {prop: 'expressGrossProfit', label: '物流毛利', width: ''},
        {prop: 'otherCost', label: '其他成本', width: ''},
        {prop: 'otherGrossProfit', label: '其他费用', width: ''},
        {prop: 'totalGrossProfit', label: '总毛利', width: ''},
        {prop: 'unitGrossProfit', label: '每单毛利', width: ''},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      /* 是否展示人工设置 */
      isShowArtificialSet: false,
      expressFeeList: [],
      expressFeeTitle: [
        {prop: 'expressName', label: '承运商', width: ''},
        {prop: 'orderNum', label: '单量', width: ''},
        {prop: 'unWeightedOrderNum', label: '未称重单量', width: ''},
        {prop: 'income', label: '运费收入', width: ''},
        {prop: 'cost', label: '运费成本', width: ''},
        {prop: 'grossProfit', label: '运费毛利', width: ''},
        {prop: 'unitGrossProfit', label: '每单毛利', width: ''},
      ],
      warehouseAreaFeeList: [],
      warehouseAreaFeeListTitle: [
        {prop: 'warehouseName', label: '仓库', width: ''},
        {prop: 'area', label: '面积', width: ''},
        {prop: 'income', label: '仓储收入', width: ''},
        {prop: 'cost', label: '仓储成本', width: ''},
        {prop: 'grossProfit', label: '仓储毛利', width: ''},
      ],
      operateFeeList: [],
      operateFeeListTitle: [
        {prop: 'warehouseName', label: '仓库', width: ''},
        {prop: 'income', label: '操作收入', width: ''},
      ],
      claimFeeList: [],
      claimFeeListTitle: [
        {prop: 'name', label: '名称', width: ''},
        {prop: 'orderNum', label: '单量', width: ''},
        {prop: 'cost', label: '金额', width: ''},
      ],
      otherFeeList: [],
      otherFeeListTitle: [
        {prop: 'name', label: '名称', width: ''},
        {prop: 'income', label: '金额', width: ''},
      ],
      otherCostList: [],
      otherCostListTitle: [
        {prop: 'name', label: '名称', width: ''},
        {prop: 'dayAmount', label: '金额', width: ''},
      ],
      laborCostSetDialog: false,
      laborCostSetForm: {
        regularCost: '',
        tempCost: ''
      },
      costAllocationRules: 1,
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('仓库日报')
    this.getWarehouse()
  },
  methods: {
    timeDefault() {
      let date = new Date();
      let s1 = formatTimeToDate(date.getTime() - 86400000)
      return s1;
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.orderQuality = value.orderQuality;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : ''
          this.isShowArtificialSet = true
          this.getTableData();
          this.initDailyDetails()
        }
      });
    },
    //获取客户数据
    getTableData() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      let currentPage = this.currentPage;
      Operate
        .getCustomerList(warehouseId, date, currentPage)
        .then(res => {
          if (res.success) {
            this.total = res.result.totalNum;
            this.tableData = res.result.items;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 日报详情
    initDailyDetails() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      Operate
        .getDailyDetails(warehouseId, date)
        .then(res => {
          if (res.success) {
            let { totalIncome, totalCost, totalGrossProfit, unitTotalGrossProfit,
            expressFeeList, warehouseAreaFeeList, operateFeeList, claimFeeList,
            otherFeeList, otherCostList } = res.result
            this.totalRevenue = totalIncome
            this.totalCost = totalCost
            this.grossProfi = totalGrossProfit
            this.itemOrderGrossProfi = unitTotalGrossProfit
            this.expressFeeList = expressFeeList
            this.warehouseAreaFeeList = warehouseAreaFeeList
            this.operateFeeList = operateFeeList
            this.claimFeeList = claimFeeList
            this.otherFeeList = otherFeeList
            this.otherCostList = otherCostList
          } else {
            this.$message.error(res.message);
          }
        });
    },
    //搜索
    searchData() {
      this.currentPage = 1;
      if (this.warehouseId && this.date) {
        this.isShowArtificialSet = true
        this.getTableData();
        this.initDailyDetails()
      } else {
        this.isShowArtificialSet = false
      }
    },
    clearData() {
      this.warehouseId = "";
      this.date = "";
      this.tableData = []
      this.isShowArtificialSet = false
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    changeCostAllocationRules() {
      let obj = this.warehouseList.find(item => {return item.id == this.warehouseId})
      this.costAllocationRules = obj.orderQuality
    },
    /* 导出 */
    exportExit() {
      let warehouseId = this.warehouseId;
      let date = this.date;
      if (!this.warehouseId) {
        return this.$message.error('请选择仓库')
      }
      if (!this.date) {
        return this.$message.error('请选择日期')
      }
      Operate.getExportExcel(warehouseId, date).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    laborCostSet() {
      this.laborCostSetDialog = true
    },
    closeDialog() {
      this.laborCostSetForm.tempCost = ''
      this.laborCostSetForm.regularCost = ''
      this.laborCostSetDialog = false
    },
    submit() {
      let warehouseId = this.warehouseId;
      let billDate = this.date;
      let tempCost = this.laborCostSetForm.tempCost
      let regularCost = this.laborCostSetForm.regularCost
      let data = {
        warehouseId,
        billDate,
        tempCost,
        regularCost
      }
      Operate.postLaborCostSet(data).then(res => {
        if (res.success) {
          this.getTableData();
          this.initDailyDetails()
          this.closeDialog()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    tempCostInput(v) {
      this.laborCostSetForm.tempCost = getDecimal(v);
    },
    regularCostInput(v) {
      this.laborCostSetForm.regularCost = getDecimal(v);
    },
    lookCustomerOrderNums(row) {
      this.$router.push({
        path: '/home/operateIndex/customerSingleReport',
        query: {
          id: row.id,
          warehouseId: this.warehouseId,
          date: this.date
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.operate {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    .statistics {
      width: 100%;
      height: 96px;
      background: #F8FAFB;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 400;
      color: #666666;
    }
    .search-left {
      display: flex;
      justify-content: space-between;
      .search-left-content {
        margin-bottom: 16px;
        display: flex;
        .el-input {
          width: 200px;
          margin-right: 16px;
        }
      }
      .search-right-content {
        display: flex;
      }
    }
    .black-grey {
      color: #333333;
    }
    .gross-profit {
      color: #2E68EA;
    }
    .el-select {
      margin-right: 16px;
    }
    .btn-blue {
      margin: 0;
    }
    .paddingRight {
      margin-right: 16px;
    }
  }
  .daily-details {
    margin-bottom: 20px;
    padding: 16px;
    .daily-container {
      margin-bottom: 20px;
      .daily-title {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
      }
    }
    .half-daily {
      display: flex;
      justify-content: space-between;
      .daily-container {
        width: 48%;
      }
    }
  }
  .table {
    background: #fff;
    border-radius: 4px;
    .hign-red {
      color: #FF0909;
    }
    .totle-price {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding: 0px 16px;
      border-bottom: 1px solid #eee;
      p {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
    }
    .table-container {
      padding: 16px;
    }
    .el-table {
      .cell {
        position: relative;
        .remarks {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-right: 14px;
        }
        .icon {
          position: absolute;
          right: 1px;
          top: 9px;
          cursor: pointer;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .cost {
    position: relative;
    &::after {
      position: absolute;
      content: '元';
      right: 9px;
      color: #666;
    }
  }
}
</style>
<style lang="scss">
.operate {
  .table {
    .el-table {
      .el-input {
        .el-input__inner {
          height: 24px;

          padding-left: 5px;
          padding-right: 0px;
        }
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  .daily-details {
    .el-table__empty-block {
      min-height: 32px;
    }
    .el-table__empty-text {
      line-height: 32px;
    }
  }
}
</style>
